module.exports = __webpack_public_path__ + "img/play-icon.e5cdb4c1.svg";